import { required, optional } from 'AppReact/schema';

export default {
    payStubID: required('string'),
    payStubUrl: required('string'),

    hasError: optional('boolean'),
    licenseIDError: optional('string'),
    payStubIDError: optional('string'),
}

export const defaultDocs = {
    payStubID: '',
    payStubUrl: '',
    
    hasError: false,
    licenseIDError: '',
    payStubIDError: '',
}
